export enum LeaderCriteriaRuleTableColumns {
  ComparisonField = "comparisonField",
  ComparisonType = "comparisonType",
  ComparisonValue = "comparisonValue",
  StatisticField = "statisticField",
  QualifierId = "qualifierId",
}
